module.exports = __webpack_public_path__ + "img/spin-dashed.9e2af77c.svg";